import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PageLayout from "examples/LayoutContainers/PageLayout";
import boxShadow from "assets/theme/functions/boxShadow";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import logo from "assets/images/logo.png";

function CoverLayout({ color, header, title, description, image, top, children, forgot }) {

	const matches = useMediaQuery("(max-width:600px)");
	const userTheme = useSelector((state) => state.commonSlice.theme);

	return (
		<PageLayout >
			<Grid container justifyContent="space-between" sx={{ minHeight: "95vh", margin: 0, }} >
				<Grid display="flex" justifyContent="center" alignItems="center" item xs={11} sm={8} md={5} xl={6}>
					<SoftBox sx={{ width: "500px" }}>
						<SoftBox pt={3} px={0}>
							{!header ? (
								<>
									<SoftBox mb={1}>
										<SoftTypography variant="h3" fontWeight="bold" color={color} textGradient>
											{title}
										</SoftTypography>
									</SoftBox>
									<SoftTypography variant="caption" fontWeight="regular" color="text">
										{description}
									</SoftTypography>
								</>
							) : (
								header
							)}
						</SoftBox>
						<SoftBox>{children}</SoftBox>
					</SoftBox>
				</Grid>
				<Grid item xs={12} md={5} xl={6}>
					<SoftBox
						sx={{
							position: "relative",
							height: "100%",
							m: 3,
							px: 7,
							borderRadius: "1rem",
							backgroundImage: `url(${logo})`,
							backgroundSize: "contain",
							backgroundPosition: "center",
							backgroundRepeat: "no-repeat",
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							overflow: "hidden",
						}}
					>
						{/* Mask Overlay */}
						<SoftBox
							sx={{
								position: "absolute",
								width: "100%",
								height: "100%",
								top: 0,
								left: 0,
								background: "linear-gradient(135deg, rgb(199, 2, 178), rgb(32, 132, 218))",
								opacity: 0.2,
								zIndex: 1,
							}}
						/>

						{/* Content */}
						{/* <SoftBox sx={{ position: "relative", zIndex: 2 }}>
							<SoftTypography
								variant="h2"
								fontWeight="bold"
								color="white"
								mt={5}
							>
								"1ONUS"
							</SoftTypography>
							<SoftTypography color="white" mt={1}>
								Discover the best Buy One Get One (BOGO) deals and exclusive discounts in dining, entertainment, retail, and more — only at 1ONUS.
							</SoftTypography>
						</SoftBox> */}
					</SoftBox>
				</Grid>
			</Grid>
		</PageLayout>
	);
}

// Setting default values for the props of CoverLayout
CoverLayout.defaultProps = {
	header: "",
	title: "",
	description: "",
	color: "info",
	top: 20,
};

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
	color: PropTypes.oneOf([
		"primary",
		"secondary",
		"info",
		"success",
		"warning",
		"error",
		"dark",
		"light",
	]),
	header: PropTypes.node,
	title: PropTypes.string,
	description: PropTypes.string,
	image: PropTypes.string.isRequired,
	top: PropTypes.number,
	children: PropTypes.node.isRequired,
};

export default CoverLayout;

// <DefaultNavbar
// action={{
//   type: "external",
//   route: "https://creative-tim.com/product/soft-ui-dashboard-react",
//   label: "free download",
//   color: "dark",
// }}
// />
